import { min } from 'ramda';
import useScrollPosition from '@react-hook/window-scroll';
export var useStickyScroll = function useStickyScroll(_ref) {
  var _ref$scrollDistance = _ref.scrollDistance,
      scrollDistance = _ref$scrollDistance === void 0 ? 60 : _ref$scrollDistance;
  var scrollY = useScrollPosition(60);
  return {
    scrollPercent: min(scrollY, scrollDistance) / scrollDistance
  };
};